import React from "react";
import moment from "moment";
import { ExistenciaAlmacenesTable } from "./ExistenciaAlmacenesTable";
import { ExistenciaBodegaTable } from "./ExistenciaBodegaTable";
import { ExistenciaSeccion } from "./ExistenciaSeccion";
import "./styles/Existencia.css";

const formatearFecha = (fecha, formato) => {
    if (!fecha) {
        return null;
    }

    return moment(fecha).format(formato);
};

// Los dos bloques del formato de existencias de un período. Cada mitad la cierra
// un cierre mensual distinto, así que cualquiera de las dos puede llegar en
// null: ese período todavía no tiene ese cierre registrado.
// El detalle las muestra igual, rotuladas como pendientes, porque el formato
// impreso es uno solo; la previsualización de un cierre pasa
// `omitirSeccionesVacias` para quedarse únicamente con la mitad que va a
// registrar
export const ResumenExistenciaContenido = ({
    resumen,
    omitirSeccionesVacias,
    observacionesProductos,
    onCambiarObservacion,
}) => {
    const bodega = resumen.bodega;
    const almacenes = resumen.almacenes;

    const cierreBodega = bodega ? bodega.cierre : null;
    const inventarioAlmacenes = almacenes ? almacenes.inventario : null;

    // cada bloque toma su propio cierre: el de bodega es diario y el de
    // almacenes mensual, por eso ambos indican de dónde salieron los datos
    const datosBodega = cierreBodega
        ? [
              { label: "Cierre de bodega", valor: cierreBodega.numero },
              {
                  label: "Fecha de corte",
                  valor: formatearFecha(
                      cierreBodega.fecha_corte,
                      "DD/MM/YYYY HH:mm",
                  ),
              },
              //   {
              //       label: "Fecha de cierre",
              //       valor: formatearFecha(
              //           cierreBodega.fecha_creacion,
              //           "DD/MM/YYYY HH:mm",
              //       ),
              //   },
          ]
        : [];

    const datosAlmacenes = inventarioAlmacenes
        ? [
              {
                  label: "Inventario cerrado",
                  valor: inventarioAlmacenes.periodo,
              },
              {
                  label: "Fecha de cierre",
                  valor: formatearFecha(
                      inventarioAlmacenes.fecha_cierre,
                      "DD/MM/YYYY HH:mm",
                  ),
              },
          ]
        : [];

    return (
        <React.Fragment>
            {(!omitirSeccionesVacias || bodega) && (
                <ExistenciaSeccion
                    titulo="BODEGA DE PRODUCTO TERMINADO"
                    datos={datosBodega}
                    sinDatos={!cierreBodega}
                    mensajeVacio="PENDIENTE — este período todavía no tiene el cierre mensual de bodega"
                >
                    <ExistenciaBodegaTable
                        padres={bodega ? bodega.padres || [] : []}
                        totales={bodega ? bodega.totales || {} : {}}
                        observaciones={observacionesProductos}
                        onCambiarObservacion={onCambiarObservacion}
                    />
                </ExistenciaSeccion>
            )}

            {(!omitirSeccionesVacias || almacenes) && (
                <ExistenciaSeccion
                    titulo="MATERIA PRIMA EN ALMACENES"
                    datos={datosAlmacenes}
                    sinDatos={!inventarioAlmacenes}
                    mensajeVacio="PENDIENTE — este período todavía no tiene el cierre mensual de materia prima"
                >
                    <ExistenciaAlmacenesTable
                        almacenes={almacenes ? almacenes.almacenes || [] : []}
                        totales={almacenes ? almacenes.totales || {} : {}}
                    />
                </ExistenciaSeccion>
            )}
        </React.Fragment>
    );
};
